import { supabase } from '../lib/supabase';

/**
 * Generic Admin Service for CRUD and CSV bulk insert
 */
const adminService = {
  async list(table, { select = '*', order = { column: 'created_at', ascending: false }, limit = 50, offset = 0 } = {}) {
    let query = supabase?.from(table)?.select(select);
    if (order?.column) query = query?.order(order.column, { ascending: !!order.ascending });
    if (limit) query = query?.limit(limit);
    if (offset) query = query?.range(offset, offset + limit - 1);
    const { data, error } = await query;
    if (error) throw error;
    return data || [];
  },

  async upsert(table, record, { onConflict } = {}) {
    let query = supabase?.from(table)?.upsert(record, { onConflict });
    const { data, error } = await query?.select()?.maybeSingle();
    if (error) throw error;
    return data;
  },

  async create(table, record) {
    const { data, error } = await supabase?.from(table)?.insert(record)?.select()?.single();
    if (error) throw error;
    return data;
  },

  async update(table, id, record, { idColumn = 'id' } = {}) {
    const { data, error } = await supabase?.from(table)?.update(record)?.eq(idColumn, id)?.select()?.single();
    if (error) throw error;
    return data;
  },

  async remove(table, id, { idColumn = 'id' } = {}) {
    const { error } = await supabase?.from(table)?.delete()?.eq(idColumn, id);
    if (error) throw error;
    return true;
  },

  async bulkInsert(table, rows, { onConflict } = {}) {
    if (!Array.isArray(rows) || rows.length === 0) return [];
    const { data, error } = await supabase?.from(table)?.upsert(rows, { onConflict })?.select();
    if (error) throw error;
    return data || [];
  }
};

export default adminService;
